<template>
  <div>
    <page-table :shipmentCode="shipmentCode" :disabled="disabled || readonly" :sourceType="sourceType" />
  </div>
</template>
<script>
import PageTable from './components/table'
export default {
  props: {
    shipmentCode: String,
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    sourceType: { type: String, default: '' },
  },
  components: { PageTable },
}
</script>
